export const EMAIL_MOBILE_MAX_WIDTH = 480;
export const EMAIL_DESKTOP_MAX_WIDTH = 640;

/**
 * Most email developers use 480px as the standard mobile breakpoint because it:
 * - Covers all iPhone models (SE through Pro Max)
 * - Includes most Android devices
 * - Provides a safety margin for edge cases
 */
export const mobileMediaQuery = `@media only screen and (max-width: ${EMAIL_MOBILE_MAX_WIDTH}px)`;
